<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="all"><strong>全部订单</strong></el-menu-item>
        <el-menu-item index="remindday" v-if="shohuif">回访<span class="badge" v-if="remindnumber>0">{{remindnumber}}</span></el-menu-item>
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <comment :is="currentcomponent" :roletype="'customerservice'" :mystatus="status" v-if="visible"
               @bindTip="bindTip"></comment>
    </el-main>
  </div>
</template>
<script>
  import CstagreementListMerge from './CstagreementListMerge';
  import waitauditList from '../../workflow/waitaudit/waitauditList';
  import {countlist, pushcount} from '@/api/set/csagreement';
  import {simulationLogin, checkModuleRight} from '@/api/login'

  export default {
    data() {
      return {
        activeIndex: 'all',
        currentcomponent: 'CstagreementListMerge',
        visible: true,
        status: 'all',
        usereturnflow: false,
        statuseslist: "650;",
        statusnumber650: 0,
        remindnumber: 0,//待回访数
        shohuif:true,

      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.status = key
        this.visible = false
        if (key == 'remindday') {
          this.currentcomponent = 'waitauditList'
        }else{
          this.currentcomponent = 'CstagreementListMerge'
        }
        this.$nextTick(() => {
          this.visible = true
        })

      },
      bindTip() {
      },
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      if (this.userInfoModel.myright.indexOf('隐藏客户手机号') > -1)
        this.shohuif = false;
    },
    components: {
      CstagreementListMerge,
      waitauditList
    }
  }

</script>
<style scoped>
  .el-main {
    padding: 0px;
    width: 100%;
    margin: 0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/CustomService.vue